module.exports = __webpack_public_path__ + "static/media/thumbnail_play_magenta.53b52d67.svg";